function findUsedSubjectAttributesInDRG(nodes) {

    const attributeMap = {};

    nodes
        .filter(node => node.type === 'subject')
        .flatMap(extractUsedAttributesFromNode)
        .forEach(attr => {
            const key = `${attr.name}::${attr.attributeType}`;
            if (!attributeMap[key]) {
                attributeMap[key] = {
                    name: attr.name,
                    attributeType: attr.attributeType,
                    count: 0
                };
            }
            attributeMap[key].count += 1;
        });

    const usedSubjectAttributeSet = attributeMap;

    return nodes.map(node => {
        if (node.type !== 'root') return node

        return {
            ...node,
            data: {
                ...node.data,
                general_properties: {
                    ...node.data.general_properties,
                    used_subject_attributes: usedSubjectAttributeSet
                }
            }
        }
    })
}

function extractUsedAttributesFromNode(node) {
    if (
        node.type === 'subject' &&
        node.data?.general_properties?.subjectConstraints
    ) {
        return node.data.general_properties.subjectConstraints.flatMap(constraint =>
            (constraint.child || []).map(child => ({
                name: child?.l_operand?.name,
                attributeType: child?.l_operand?.attributeType
            }))
        ).filter(attr => attr.name && attr.attributeType)
    }

    // case อื่นๆ
    return []
}

export default findUsedSubjectAttributesInDRG